module.exports = __webpack_public_path__ + "static/media/ukraine.ade4206e.svg";